import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Projekte/Experimente/github/react-gsap/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Fragment } from 'react';
import { Playground, Props } from 'docz';
import { Controls, PlayState, SplitChars } from './../../../react-gsap/src/';
import { Tween } from './Tween';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "splitchars"
    }}>{`SplitChars`}</h1>
    <p>{`The SplitChars component is a small helper that splits a text by chars and returns one component per char.`}</p>
    <pre><code parentName="pre" {...{}}>{`import { Controls, PlayState, Tween, SplitChars } from 'react-gsap';
`}</code></pre>
    <h2 {...{
      "id": "usage-with-tween"
    }}>{`Usage with Tween`}</h2>
    <Playground __position={0} __code={'<Controls playState={PlayState.stop}>\n  <Tween from={{ x: \'200px\' }} stagger={0.1}>\n    <SplitChars\n      wrapper={<div style={{ display: \'inline-block\', fontSize: \'40px\' }} />}\n    >\n      This text gets splitted by chars.\n    </SplitChars>\n  </Tween>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Controls,
      PlayState,
      SplitChars,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Tween from={{
          x: '200px'
        }} stagger={0.1} mdxType="Tween">
      <SplitChars wrapper={<div style={{
            display: 'inline-block',
            fontSize: '40px'
          }} />} mdxType="SplitChars">
        This text gets splitted by chars.
      </SplitChars>
    </Tween>
  </Controls>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      